import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import contactService from "./contactService";

const errMsg = (error) =>
  error.response?.data?.message || error.message || "Something went wrong";

const makeThunk = (type, fn) =>
  createAsyncThunk(type, async (arg, thunkAPI) => {
    try {
      return await fn(arg);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || { message: errMsg(error) });
    }
  });

export const fetchContacts = makeThunk("contact/fetchAll", async (params) => (await contactService.getAll(params)).data);
export const updateContact = makeThunk("contact/update", async (data) => (await contactService.update(data)).data);
export const deleteContact = makeThunk("contact/delete", async (id) => {
  await contactService.remove(id);
  return id;
});

const contactSlice = createSlice({
  name: "contact",
  initialState: {
    list: [],
    isLoading: false,
    isSaving: false,
    isError: false,
    message: "",
    errors: {},
  },
  reducers: {
    clearContactError: (state) => {
      state.isError = false;
      state.message = "";
      state.errors = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContacts.pending, (s) => { s.isLoading = true; })
      .addCase(fetchContacts.fulfilled, (s, a) => { s.isLoading = false; s.list = a.payload; })
      .addCase(fetchContacts.rejected, (s, a) => {
        s.isLoading = false; s.isError = true;
        s.message = a.payload?.message || "Failed to load messages";
      })

      .addCase(updateContact.pending, (s) => { s.isSaving = true; s.isError = false; s.errors = {}; })
      .addCase(updateContact.fulfilled, (s, a) => {
        s.isSaving = false;
        s.list = s.list.map((m) => (m.id === a.payload.id ? a.payload : m));
      })
      .addCase(updateContact.rejected, (s, a) => {
        s.isSaving = false; s.isError = true;
        s.message = a.payload?.message || "Update failed";
        s.errors = a.payload?.errors || {};
      })

      .addCase(deleteContact.pending, (s) => { s.isSaving = true; s.isError = false; })
      .addCase(deleteContact.fulfilled, (s, a) => {
        s.isSaving = false;
        s.list = s.list.filter((m) => m.id !== a.payload);
      })
      .addCase(deleteContact.rejected, (s, a) => {
        s.isSaving = false; s.isError = true;
        s.message = a.payload?.message || "Delete failed";
      });
  },
});

export const { clearContactError } = contactSlice.actions;
export default contactSlice.reducer;